import Image from "@/components/Image";
import tokenomicsContainer from "@/assets/images/tokenomics-container.svg";

import BasicText from "@/components/BasicText";
import Title from "@/components/Title";

interface TokenomicsContainerProps {
  title: string;
  percent: number;
  className?: string;
}

const TokenomicsComponent: React.FC<TokenomicsContainerProps> = ({
  title,
  percent,
  className,
}) => {
  return (
    <div className={`absolute ${className}`}>
      <div className="relative flex-1 max-w-[200px] min-w-[200px] h-[100px]">
        <Image
          src={tokenomicsContainer}
          alt="container"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center gap-2">
          <BasicText className="text-[14px] text-gray-400">{title}</BasicText>
          <Title className="text-[24px]">{percent}%</Title>
        </div>
      </div>
    </div>
  );
};

export default TokenomicsComponent;
